import { Divider, Form, Input, Radio, Slider } from "antd";
import {
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
} from "@ant-design/icons";
import ContentPadding from "../ContentConfig/ContentPadding";
import { ColorPickerFormItem } from "../Image/ImageConf";
import ContentID from "../Common/ContentID";
import { useState } from "react";

export default ({ node }) => {
  const [couponType, setCouponType] = useState(node.data.type || "string");
  const handleTypeChange = (e) => {
    setCouponType(e.target.value);
  };
  return (
    <>
      <Form.Item label="Coupon Type" name="type" initialValue="string">
        <Radio.Group onChange={handleTypeChange} value={couponType}>
          <Radio value="string">String</Radio>
          <Radio value="qrcode">QRCode</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        label={couponType === "qrcode" ? "URL" : "Content"}
        required
        name="content"
      >
        <Input
          placeholder={
            couponType === "qrcode"
              ? "Enter the URL for QR Code"
              : "Enter coupon code"
          }
        />
      </Form.Item>
      <Divider />
      <Form.Item label="Width" name="width">
        <Slider
          style={{ width: "100%" }}
          min={0}
          max={100}
          marks={{ 0: "-", 100: "+" }}
          tipFormatter={(v) => `${v}%`}
        />
      </Form.Item>
      <Form.Item label="Height" name="height">
        <Slider
          style={{ width: "100%" }}
          min={0}
          max={100}
          marks={{ 0: "-", 100: "+" }}
          tipFormatter={(v) => `${v}%`}
        />
      </Form.Item>
      {couponType === "string" && (
        <>
          <ColorPickerFormItem
            label="Color"
            name="color"
            color={node.data.color}
          />
        </>
      )}

      <Form.Item label="Alignment" name="align">
        <Radio.Group
          style={{ margin: "12px 0 0 0" }}
          options={[
            { label: <AlignLeftOutlined />, value: "left" },
            { label: <AlignCenterOutlined />, value: "center" },
            { label: <AlignRightOutlined />, value: "right" },
          ]}
          defaultValue="center"
          optionType="button"
        />
      </Form.Item>
      <Divider />
      <ContentID />
      <Divider />
      <ContentPadding />
    </>
  );
};
